module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/injection/masse/collaborators/collaborators.component.css
// module id = ./src/app/modules/injection/masse/collaborators/collaborators.component.css
// module chunks = main